// Internal modules
import { $logger } from '../logger';

const parseGqlError = (result = {}) => {
  /**
   * `result?.response?.errors?.[0]`:
   * `graphql-request` uses an Error object wrapper with the request and
   * response information. In this case `result.response` is the response
   * from the network call.
   * https://github.com/prisma/graphql-request/blob/v1.8.2/src/types.ts#L38
   *
   * `result`:
   * This is used when the we manually throw an error
   */
  const error = result?.response?.errors?.[0] || result;
  const { data, errorData, message = '' } = error;

  return {
    error,
    errorData: errorData || data || [],
    isFiConfirmationContingency: message === 'FI_CONFIRMATION_CONTINGENCY',
    isOasError: message === 'OAS_ERROR',
    message,
  };
};

/**
 * @function validateGraphQLResponse
 * @param {object} data
 * @param {string} operation
 * @description Checks if the response of a GraphQL call has an error
 * attached to it and if it does an Error is thrown.
 */
const validateGraphQLResponse = (data, operation, errorMessage) => {
  const error = data?.errors?.[0];

  if (error) {
    $logger.error(`weasley_${operation}_err`, {
      message: error.message,
    });
    throw new Error(errorMessage || error.message);
  }

  $logger.info(`weasley_${operation}_success`);
};

export { parseGqlError, validateGraphQLResponse };
